<template>
    <tile class="tenders" link="tenders">
        <div class="tenders__header" slot="tileHeader">
            <tile-title icon="gavel">Тендеры</tile-title>
            <app-switcher
                :leftClickHandler="toggle"
                :rightClickHandler="toggle"
                :isLeftDisabled="!participantYears.length"
                :isRightDisabled="!customerYears.length"
            >
                <span slot="leftValue">Участник</span>
                <span slot="rightValue">Заказчик</span>
            </app-switcher>
        </div>

        <div class="tenders__content" slot="tileContent">
            <app-transition
                :showLeftIf="type === 'participants'"
                :showRightIf="type === 'customers'"
            >
                <participant slot="left" ref="participant" />
                <customer slot="right" ref="customer" />
            </app-transition>
            <tenders-modal v-if="isModal" :title="title" />
        </div>

        <div class="tenders__footer" slot="tileFooter">
            <tile-print-pdf
                :html="htmlString"
                :title="title"
                filename="Tenders"
                :printStyle="printStyle" 
            />
        </div>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import appSwitcher from '@/components/ui/appSwitcher/appSwitcher.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import appTransition from '@/components/ui/appTransition/appTransition.vue'
import participant from '@/components/card/tenders/participant.vue'
import customer from '@/components/card/tenders/customer.vue'
import tendersModal from '@/components/card/tenders/tendersModal.vue'

export default {
    components: {
        tile,
        tileTitle,
        appSwitcher,
        tilePrintPdf,
        appTransition,
        participant,
        customer,
        tendersModal
    },
    data() {
        return {
            htmlString: '',
            printStyle: `
                .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
                }
                .print-grey, tr th { background: #ddddde; font-weight: 600; },
                tfoot tr td { font-weight: 600;}
                tr button { border: none; background: none; }
                table caption { font-size: 20px; font-weight: 600; margin: 30px 0 5px 0; }
                .uk-icon-rub:before {  
                content: "\\20BD";
                font-style: normal;
            }

            `
        }
    },
    computed: {
        ogrn() { return this.$store.state.card?.company?.ogrn },
        type() { return this.$store.state.card?.tenders?.type },
        isModal() { return this.$store.state.card?.tenders?.isModal },
        participantYears() { return this.$store.getters['card/tenders/participantYears'] },
        customerYears() { return this.$store.getters['card/tenders/customerYears'] },
        stats() { return this.$store.state.card?.tenders?.stats },
        companyName() { return this.$store.state.card?.company?.name_short || this.$store.state.card?.company?.name_full },
        title() { return `Тендеры | ${this.companyName}` }
    },
    methods: {
        toggle() { this.$store.commit('card/tenders/changeType') }
    },
    mounted() {
        this.$store.dispatch('card/tenders/getTendersStat', Number(this.ogrn))
            .finally(() => {
                if(!this.participantYears?.length && !this.customerYears?.length) {
                    this.$store.dispatch('card/disableTile', 'tenders')
                }

                    if(!this.participantYears?.length) {
                        $('#tenders-participant-label').html('<span>Не является участником в тендерах</span>')
                    } else {
                        $('#tenders-participant-label').html(`
                            <span class="tenders-participant-link uk-pseudolink">
                                Победитель в ${this.stats?.participant?.total?.lots_win} из ${this.stats?.participant?.total?.lots_total} тендерах
                            </span>
                        `)
                        $('.tenders-participant-link').on('click', e => {
                            e.preventDefault()
                            window.scrollToElement('tenders-tile-link')
                        })
                    } 

                if(!this.customerYears?.length) {
                    $('#tenders-customer-label').html('<span>Не является заказчиком в тендерах')
                } else {
                    $('#tenders-customer-label').html(`
                        <span class="tenders-customer-link uk-pseudolink">
                           Заказчик в ${this.stats?.customer?.total?.lots_not_contr} тендерах
                        </span>
                    `)
                    $('.tenders-customer-link').on('click', e => {
                        e.preventDefault()
                        window.scrollToElement('tenders-tile-link')
                        $('.switcher__btn.right').click()
                    })
                }
                this.$nextTick(() => {
                    this.htmlString = (this.$refs.participant?.$refs?.table?.$el?.outerHTML || '') + (this.$refs.customer?.$refs?.table?.$el?.outerHTML || '') 
                })
            })
        this.$store.dispatch('card/tenders/getProductsStat', Number(this.ogrn))
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.tenders
    &__header
        @include flex-between
    &__footer
        display: flex
        justify-content: flex-end
        align-items: center
</style>